import type { IVariable, IVariableType } from '@carboncopyco/types';
import { LoadingDots, notify } from '@carboncopyco/ui';
import { useBoolean } from 'ahooks';
import classNames from 'classnames';
import type React from 'react';
import { ImageVariableForm } from './ImageVariableForm';
import { TextVariableForm } from './TextVariableForm';
import type { VariableFormBaseProps } from './types';

export interface VariableFormProps extends VariableFormBaseProps {
  type: IVariableType;
}

const variableTypeToForm: Record<IVariableType, React.ElementType> = {
  text: TextVariableForm,
  image: ImageVariableForm,
};

export const VariableForm = ({ type, ...props }: VariableFormProps) => {
  const [isSubmitting, setIsSubmitting] = useBoolean();
  const Form = variableTypeToForm[type];

  const submitForm = async (variable: IVariable) => {
    const { onSubmit } = props;
    setIsSubmitting.setTrue();
    try {
      await onSubmit(variable);
    } catch (error) {
      notify.error('Failed to create variable, please try again.');
      throw error;
    } finally {
      setIsSubmitting.setFalse();
    }
  };

  return (
    <div className="relative">
      <div
        className={classNames({
          'opacity-0': isSubmitting,
        })}
      >
        <Form
          {...props}
          onSubmit={submitForm}
        />
      </div>
      {isSubmitting && (
        <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center">
          <LoadingDots />
        </div>
      )}
    </div>
  );
};
